import Vue from 'vue'
import App from './App.vue'
import router  from './router'
import store from './store'

import Cookies from 'js-cookie'
import Element from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import '@/assets/fonts/font.css'

import "animate.css"
import './permission';
import echarts from "echarts";
Vue.prototype.$echarts = echarts;


Vue.use(Element, {
  size: Cookies.get('size') || 'medium' // set element-ui default size
})

Vue.config.productionTip = false
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
